import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import { getRequest } from "services/api";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

// Membuat context untuk loading
const DiscountContext = createContext();

// Provider untuk context loading
export const DiscountProvider = ({ children }) => {
  const [discounts, setDiscounts] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    limit: LIMIT_DATA_PER_PAGE,
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchDiscounts = useCallback(async () => {
    setDiscounts((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/discount${queryString}`);
      if (response.success) {
        setDiscounts({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });

        setFilterOptions((prev) => ({
          ...prev,
          totalPages: response.pagination.last_page,
        }));
      }
    } catch (error) {
      setDiscounts({
        data: [],
        pagination: null,
        error: error.message,
        loading: false,
      });
    }
  }, [queryString]);

  useEffect(() => {
    fetchDiscounts();
  }, [queryString]);

  const handlePageChange = (page) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  const totalPages = discounts.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages: totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  return (
    <DiscountContext.Provider
      value={{
        discounts,
        handleSearch,
        filterOptions,
        Pagination,
        refetch: fetchDiscounts,
      }}
    >
      {children}
    </DiscountContext.Provider>
  );
};

// Hook untuk mengakses context loading
export const useDiscount = () => {
  const context = useContext(DiscountContext);
  if (!context) {
    throw new Error("useDiscount must be used within a DiscountContext");
  }
  return context;
};
